import header from "../static/svg/header-logo.svg";
import plus from "../static/svg/plus-logo.svg";
import assetsIcon from "../static/images/assetsIcon.png";
import teamsIcon from "../static/images/teamsIcon.png";
import signoutIcon from "../static/images/signoutIcon.png";
import { useNavigate, Link } from "react-router-dom";
import CreateNewModal from "./CreateNewModal";
import { useState } from "react";
import { Search } from "tabler-icons-react";
import { useDispatch, useSelector } from "react-redux";
import ReactRoundedImage from "react-rounded-image";
import {
	Box,
	Button,
	Container,
	Group,
	Image,
	MediaQuery,
	Menu,
	Input,
	Header,
} from "@mantine/core";
import axios from "axios";
import { CDN_URL, LOCAL_URL } from "../constant";
import MenuItem from "./MenuItem";
import { showSuccessNotification } from "../utils/Notifications";
import { logoutAction } from "../services/Action/userAction";

function Headr({ isSearch, refresh }) {
	const [opened, setOpened] = useState(false);
	const user = useSelector((state) => state.userInformationReducer.users);
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const logout = () => {
		axios
			.get(`${LOCAL_URL}/api/auth/logout`, {
				withCredentials: true,
			})

			.then((rs) => {
				showSuccessNotification("Logout Sucessfully");
				navigate("/login");
				dispatch(logoutAction());
			});
	};
	let navigator = useNavigate();
	return (
		<Header
			style={{
				background: "#040F1F",
				border: "none",
				position: "relative",
			}}
		>
			<Group
				px={10}
				position="apart"
				style={{
					background: "#09254E",
					padding: "8px 5px",
					border: "none",
				}}
			>
				<div
					style={{ padding: "0px 0px 0px 10px" }}
					className=" headercolumn1"
				>
					<Box>
						<Link to="/dashboard">
							<Image src={header} width={100} />
						</Link>
					</Box>
				</div>
				{isSearch && (
					<div className="col-md-5 col-sm-4 col-xs-5 headercolumn2 ">
						<div style={{ width: "100%" }}>
							<Input
								rightSection={<Search size={16} />}
								placeholder="Search"
								styles={{
									input: { backgroundColor: "#252E3D" },
									root: {
										width: "50%",
										color: "#fffffff",
									},
								}}
							/>
						</div>
					</div>
				)}
				<div className=" headercolumn3">
					<Container
						style={{
							display: "flex",
							padding: "0 3px 0 0",
							width: "max-content",
							position: "relative",
						}}
					>
						<Group>
							<MediaQuery smallerThan="sm">
								<Button
									onClick={() => setOpened(true)}
									style={{
										color: "white",
										borderRadius: "50px",
									}}
									leftIcon={
										<Image src={plus} width={15} pt={0} />
									}
								>
									Create new
								</Button>
							</MediaQuery>
						</Group>
						{opened && (
							<CreateNewModal
								refresh={refresh}
								opened={opened}
								setOpened={setOpened}
							/>
						)}
						<Menu
							shadow="sm"
							width={120}
							styles={{
								dropdown: {
									backgroundColor: "rgb(9, 37, 78)",
								},
							}}
						>
							<Menu.Target>
								<Button
									style={{
										background: "#09254E",
										borderRadius: "0",
									}}
								>
									<ReactRoundedImage
										imageWidth="28"
										imageHeight="28"
										roundedSize="0"
										image={
											user?.userProfile &&
											CDN_URL + user?.userProfile
										}
									/>
								</Button>
							</Menu.Target>
							<Menu.Dropdown>
								<Menu.Label style={{ color: "white" }}>
									{user?.FirstName}
								</Menu.Label>
								<MenuItem
									Name="Profile"
									RoundedImage={
										user?.userProfile &&
										CDN_URL + user?.userProfile
									}
									menuItemHandler={() =>
										navigator("/profile")
									}
								/>
								<MenuItem
									Name="Assets"
									RoundedImage={assetsIcon}
									menuItemHandler={() => navigator("/assets")}
								/>
								<MenuItem
									Name="Team"
									RoundedImage={teamsIcon}
									menuItemHandler={() =>
										navigator("/adduser")
									}
								/>
								<MenuItem
									Name="Sign Out"
									RoundedImage={signoutIcon}
									menuItemHandler={() => logout()}
								/>
							</Menu.Dropdown>
						</Menu>
					</Container>
				</div>
			</Group>
		</Header>
	);
}
export default Headr;
